import LoaddingPage from './LoaddingPage.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'loaddingPage', LoaddingPage);
  },
};
